<template>
  <div class="main-content">
    <div class="conetnt-top">
      <div class="content-top-title">
        <span class="top-title">业绩调整</span>
      </div>
      <div class="content-top-form">
        <el-form
          :inline="true"
          :model="searchForm"
          ref="ruleForm"
          label-width="120px"
          size="medium"
        >
          <el-form-item prop="saleCode" label="编码">
            <el-input
              v-model="searchForm.saleCode"
              clearable
              placeholder="请输入编码"
              maxlength="200"
            ></el-input>
          </el-form-item>
          <el-form-item prop="saleName" label="名称">
            <el-input
              v-model="searchForm.saleName"
              clearable
              placeholder="请输入名称"
              maxlength="200"
            ></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="primary" size="small" @click="handleSearch"
              >查询</el-button
            >
            <el-upload
              style="display: inline"
              action
              :on-change="(file, fileList) => handleChange(file, fileList)"
              :auto-upload="false"
              :show-file-list="false"
              accept=".xls,.xlsx"
            >
              <el-button size="small" style="margin: 0 10px" type="primary"
                >导入数据</el-button
              >
            </el-upload>

            <el-button type="primary" size="small" @click="downloadTemplate"
              >下载模板</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content-middle" style="padding-top: 10px; padding-bottom: 10px">
      <div class="middle-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          ref="tableRef"
          :header-cell-style="{ background: '#F5F7FA', color: '#5C6474' }"
        >
          <el-table-column label="编码" prop="saleCode" align="center" />
          <el-table-column label="名称" prop="saleName" align="center" />
          <el-table-column label="调整日期" prop="targetDate" align="center" />
          <el-table-column
            label="经营收入（含税）"
            prop="orderRemainingRefundableTotal"
            align="center"
          />
          <el-table-column
            label="经营收入（无税）"
            prop="orderAmountExcludingTax"
            align="center"
          />
          <el-table-column
            label="考核收入（含税）"
            prop="orderRemainingRefundableTotalAccounting"
            align="center"
          />
          <el-table-column
            label="考核收入（无税）"
            prop="orderAmountExcludingTaxAccounting"
            align="center"
          />
          <el-table-column
            label="业务类型"
            prop="businessTypeName"
            align="center"
          />
          <el-table-column
            label="调整口径"
            prop="accountingFlagName"
            align="center"
          />
          <el-table-column label="导入人员" prop="updateBy" align="center" />
          <el-table-column label="导入日期" prop="updateTime" align="center" />
        </el-table>
        <div class="middle-pagination">
          <el-pagination
            :current-page="searchForm.pageNum"
            :page-sizes="searchForm.sizes"
            :page-size="searchForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchForm.total"
            @current-change="onChangePageNum"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Company",
  data() {
    return {
      tableData: [],
      searchForm: {
        saleName: "",
        saleCode: "",
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    downloadTemplate() {
      this.axios.get("saleAdjustdownloadTemplate", {}).then((result) => {
        console.log("result instanceof Blob", result);
        if (result instanceof Blob) {
          const blob = new Blob([result]);
          console.log(blob);
          const fileName = "业绩调整表" + ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error("导出失败！");
        }
      });
    },
    handleChange(file, fileList) {
      let formData = new FormData();
      formData.append("file", file.raw);
      console.log(formData);
      this.upload_file(formData);
    },
    upload_file(val) {
      let params = val;
      this.$store.dispatch("app/setLoading", true);
      console.log(params);
      this.axios
        .post("saleAdjustimportData", val)
        .then((result) => {
          console.log("查询返回", result);
          if (result.code === 0) {
            this.$message({
              message: "导入成功",
              type: "success",
            });
            this.getList();
          } else {
            const str = result.msg.replace(/(\n|\r|\r\n|↵)/g, "<br/>");
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message: str,
            });
          }
          this.$store.dispatch("app/setLoading", false);
        })
        .catch(() => {
          this.$store.dispatch("app/setLoading", false);
        });
    },
    handleSearch() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.searchForm.pageNum = 1;
          this.getList();
        }
      });
    },
    onChangePageNum(pageNum) {
      this.searchForm.pageNum = pageNum;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.getList();
    },
    getList() {
      this.axios
        .get(
          "saleAdjustqueryList",
          Object.assign({}, this.searchForm, {
            size: this.searchForm.pageSize,
            current: this.searchForm.pageNum,
          }),
        )
        .then((result) => {
          console.log("result", result);
          this.tableData = result.data.records;
          this.searchForm.total = result.data.total;
        });
    },
  },
};
</script>
<style scoped>
.conetnt-top {
  border-radius: 8px;
  background: #ffffff;
  padding: 12px 24px;
}

.content-top-title {
  padding-bottom: 19px;
}

.top-title {
  font-weight: 500;
  color: #303133;
  font-size: 18px;
  padding-right: 13px;
}

.top-desc {
  color: #606266;
  font-size: 14px;
}

.el-icon-question {
  color: #c0c4cc;
}

.top-form {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.form-item {
  width: 25%;
  padding: 0 12px;
  padding-left: 0;
  margin-bottom: 12px;
}

.form-item-components {
  width: 100%;
}

.form-item-components >>> .require-icon:before {
  content: "*";
  color: #f56c6c;
  margin-left: 10px;
  padding-top: 3px;
  height: 100%;
  display: block;
}

.search-btns {
  width: 100%;
  padding-right: 12px;
  text-align: right;
}

.content-middle {
  padding: 24px;
  margin-top: 24px;
  background: #ffffff;
  box-shadow: 0px 4px 32px 0px rgba(64, 98, 117, 0.12);
  border-radius: 8px;
}

.middle-data {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.middle-data-item {
  width: 24%;
  padding: 24px;
  border-radius: 8px;
}

.middle-data-item:nth-child(1) {
  background: #c6e6f5;
}

.middle-data-item:nth-child(2) {
  background: #c6e6f5;
}

.middle-data-item:nth-child(3) {
  background: #cbedea;
}

.middle-data-item:nth-child(4) {
  background: #f3d9ee;
}
.item-title {
  font-size: 14px;
  font-weight: 400;
  color: #606266;
}
.item-number {
  padding-top: 16px;
  font-size: 28px;
  font-weight: 500;
  color: #303133;
}

.middle-table {
  padding-top: 23px;
  width: 100%;
}

.middle-pagination {
  padding-top: 10px;
  text-align: right;
}
</style>
